/**
 * FeatureFlagsContext — charge /api/flags au boot et expose `useFeatureFlag(key)`.
 * Si le flag est OFF pour le rôle courant → le composant retourne null.
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext({ enabled: [], role: "user", loaded: false, refresh: () => {} });

export function FeatureFlagsProvider({ children }) {
  const [state, setState] = useState({ enabled: [], role: "user", loaded: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/flags");
      setState({
        enabled: data?.data?.enabled || [],
        role: data?.data?.role || "user",
        loaded: true,
      });
    } catch {
      setState({ enabled: [], role: "user", loaded: true });
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 120_000); // refresh every 2 min
    return () => clearInterval(t);
  }, [refresh]);

  return <Ctx.Provider value={{ ...state, refresh }}>{children}</Ctx.Provider>;
}

export function useFeatureFlag(key) {
  const { enabled, loaded } = useContext(Ctx);
  return { isEnabled: !loaded ? true : enabled.includes(key), loaded };
}

export function useAllFlags() {
  return useContext(Ctx);
}

/** Wrapper : ne render ses enfants que si le flag est actif. */
export function Feature({ flag, fallback = null, children }) {
  const { isEnabled } = useFeatureFlag(flag);
  return isEnabled ? children : fallback;
}
